/**
 * Converts a name/string into a URL-friendly slug
 * @param {string} name - The name to convert
 * @returns {string} - URL-friendly slug
 */
export const generateSlug = (name) => {
  if (!name) return '';

  return name
    .toLowerCase() // Convert to lowercase
    .trim() // Remove whitespace from start and end
    .replace(/[^\w\s-]/g, '') // Remove special characters (keep alphanumeric, spaces, hyphens)
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple consecutive hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
};

/**
 * Validates a slug format
 * @param {string} slug - The slug to validate
 * @returns {boolean} - True if valid slug format
 */
export const isValidSlug = (slug) => {
  return /^[a-z0-9-]+$/.test(slug);
};
